<template lang="pug" src="./v-resales-list-item.pug"></template>
<style lang="scss" src="./v-resales-list-item.scss" scoped></style>

<script>
export default {
    props: {
        data: {
            type: Object,
            default: null
        }
    }
};
</script>
